/** The roles an account can hold, in the order the pickers list them. */
export const ROLE_OPTIONS = [
  { value: 'admin', label: 'Admin' },
  { value: 'receptionist', label: 'Receptionist' },
  // { value: 'head_designer', label: 'Head Designer' },  // post open — restore with the role
  { value: 'designer', label: 'Designer' },
  { value: 'accountant', label: 'Accountant' },
  { value: 'store_keeper', label: 'Store Keeper' },
  { value: 'dispatcher', label: 'Dispatcher' },
  { value: 'city_office_manager', label: 'City Office Manager' },
  { value: 'supervisor', label: 'Supervisor' },
  { value: 'driver', label: 'Driver' },
  { value: 'binder', label: 'Binder' },
];

export const ROLE_LABEL = Object.fromEntries(ROLE_OPTIONS.map(r => [r.value, r.label]));

// no 0/O or 1/l/I — these get read out over a noisy floor
const SAFE_CHARS = 'abcdefghjkmnpqrstuvwxyz23456789';
export const randomPassword = () =>
  Array.from({ length: 6 }, () => SAFE_CHARS[Math.floor(Math.random() * SAFE_CHARS.length)]).join('');
